var state = {
  gradeshow: false, //资源列表关闭

  Plat: [], //平台列表
  Platlavel: "0", //
  Platname: "个人资源", //
  Platactiveid: "0", //
  subnavs: [
    {
      text: "课件",
      restype: "schkejian",
      icon1:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/kejian1.png",
      icon2:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/kejian2.png"
    },
    {
      text: "教案",
      restype: "schjiaoan",
      icon1:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/jiaoan1.png",
      icon2:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/jiaoan2.png"
    },
    {
      text: "习题",
      restype: "schxiti",
      icon1: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/xiti1.png",
      icon2: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/xiti2.png"
    },
    {
      text: "微课",
      restype: "schweike",
      icon1:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/weike1.png",
      icon2: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/weike2.png"
    },
    {
      text: "教材",
      restype: "book",
      icon1: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/book1.png",
      icon2: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/book2.png"
    },
    {
      text: "其他",
      restype: "schqita",
      icon1:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/other1.png",
      icon2: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/other2.png"
    }
  ],
  bookList: [], //教材列表
  subactive: 0,
  restype: "schkejian", //类型
  order: 0, //排序类型 0表示按时间筛选,1表示按下载量筛选,2大小order
  sort: 2, //排序方式 1正序 2倒序
  ziyuanlist: [], //校本资源列表
  xbtotal: 0, //总数
  xbpagesize: 30, //条数
  xbpage: 1, //页数
  xbloading: false,

  // 学段 科目 版本 侧别
  ceshi: [], //章节搜索
  clickchap: "",
  chapterides: {
    xueduan_id: 1,
    subject_id: 1,
    version_id: 1,
    cebie_id: 1
  },
  chapteridesarr: [1, 1, 1, 1],
  showchapterides: ["1小学", "1语文", "1人民教育出版社", "1一年级上册"],
  chapteridname: "小学/语文/人民教育出版社/一年级下册", //选中年级名称
  chapterid: "1一年级上册", //nianjiid
  xuduankemu: ["2初中", "4语文"], //学段科目默认选中
  xkid: "", //选中传值id
  xkname: "", //名称科目
  xk: {
    xueduan_id: 1,
    subject_id: 1
  },
  zjcheck: ["1人民教育出版社", "1一年级上册"],
  zjname: "人民教育出版社/一年级上册", //章节册别
  zjid: [], //章节册别
  changzjid: [], //章节配对

  trees: [], //章节
  tree_info: [], //第一章第一小节
  jie: "",
  tree_infos: [], //小节id

  search: [
    {
      name: "按上传者姓名",
      value: 1
    },
    {
      name: "按文件名称",
      value: 2
    }
  ],
  select: 2, //默认搜索条件
  searchcontent: "", //搜索内容
  searchtype: 2, //搜索类型

  // -------------------授课
  skziyuanlist: [], //授课资源列表
  skchapterides: {
    xueduan_id: 1,
    subject_id: 1,
    version_id: 1,
    cebie_id: 1
  },
  skchapteridesarr: [1, 1, 1, 1],
  skshowchapterides: ["1小学", "1语文", "1人民教育出版社", "1一年级上册"],
  skchapteridname: "小学/语文/人民教育出版社/一年级下册", //选中年级名称
  skchapterid: "1一年级上册", //nianjiid
  // sknewtrees:[],//新授课章节目录
  sktrees: [], //章节
  sktree_info: [], //第一章第一小节
  skjie: "",
  sktree_infos: [], //小节id
  sktreestring: "选择章节/目录",
  skPlatlavel: "0", //
  skPlatname: "个人资源", //
  skPlatactiveid: "0", //
  sksubactive: 0,
  skrestype: "schkejian", //类型
  skorder: 0, //排序类型 0表示按时间筛选,1表示按下载量筛选,2大小order
  sksort: 1, //排序方式 1正序 2倒序
  skziyuanlist: [], //校本资源列表
  sktotal: 0, //总数
  skpagesize: 20, //条数
  skpage: 1, //页数
  skloading: false,
  checkedlist: [], //备课页面选中的列表
  skcanup: false, //能否继续执行
  bskchecklist: "", //授课选择资源列表
  bskchecklistfolder: [],
  // 备课页文件
  listcheck: [
    {
      restype: "schkejian",
      name: "课件",
      icon:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/kejian1.png",
      list: [],
      open: false
    },
    {
      restype: "schjiaoan",
      name: "教案",
      icon:
        "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/jiaoan1.png",
      list: [],
      open: false
    },
    {
      restype: "schxiti",
      name: "习题",
      icon: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/xiti1.png",
      list: [],
      open: false
    },
    {
      restype: "schweike",
      name: "微课",
      icon: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/weike1.png",
      list: [],
      open: false
    },
    {
      restype: "schqita",
      name: "其他",
      icon: "https://sxzhuoyu.oss-cn-qingdao.aliyuncs.com/newbsk/bk/other1.png",
      list: [],
      open: false
    }
  ],
  floderlist: [], //文件列表
  skselect: 2, //默认搜索条件  1人  2名称
  sksearchcontent: "", //搜索内容
  sksearchtype: 2, //搜索类型

  // ---------------审核员审核列表
  ShenheList: [], //审核列表
  shloading: false,
  // 未审核
  shpage: 1,
  shpagesize: 20,
  shtotal: 0,
  // 审核过
  shedpage: 1,
  shedpagesize: 20,
  shedtotal: 0
};
export default state;



// WEBPACK FOOTER //
// ./src/store/modules/xiaoben/state.js